// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { ResourceValidationResultFragmentFragment } from '../../../../shared/graphql/fragments/generated/resource-validation-result.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ValidateCustomerForPsQueryVariables = Types.Exact<{
  upsertCustomerDTO: Types.UpsertCustomerDtoInput;
}>;


export type ValidateCustomerForPsQueryResult = { __typename?: 'Query', validateCustomerForPs: Array<{ __typename?: 'ResourceValidationResultDTO', resourceId: number, validationErrors: Array<{ __typename?: 'ValidationErrorDTO', errorCode: string, fieldName: string | null, translationKey: string } | null> | null }> };

export const ValidateCustomerForPsGql = gql`
    query ValidateCustomerForPs($upsertCustomerDTO: UpsertCustomerDTOInput!) {
  validateCustomerForPs(upsertCustomerDTO: $upsertCustomerDTO) {
    ...ResourceValidationResultFragment
  }
}
    ${ResourceValidationResultFragmentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateCustomerForPsInjectable extends Apollo.Query<ValidateCustomerForPsQueryResult, ValidateCustomerForPsQueryVariables> {
    override document = ValidateCustomerForPsGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */